'use strict';
const mmWidgets = require('../widgets/mm-widgets'),
	CORNER_RADIUS_BOUNDS = require('../models/corner-radius-bounds');
mmWidgets.fn.themeStyleCornerRadiusWidget = function (mapThemeModel) {
	const getCurrentSize = (themeNodeStyle) => {
			const size = mapThemeModel.getThemeAttribute(['node'], [themeNodeStyle, 'default'], ['cornerRadius']);
			return parseFloat(size) || CORNER_RADIUS_BOUNDS.min;
		},
		setSize = (themeNodeStyle, size) => {
			mapThemeModel.overrideThemeAttribute(['node', themeNodeStyle, 'cornerRadius'], size || undefined);
		},
		incrementCornerRadius = (themeNodeStyle, increment) => {
			const current = getCurrentSize(themeNodeStyle),
				newSize = current + increment;

			if (newSize < CORNER_RADIUS_BOUNDS.min) {
				setSize(themeNodeStyle, CORNER_RADIUS_BOUNDS.min);
			} else if (newSize > CORNER_RADIUS_BOUNDS.max) {
				setSize(themeNodeStyle, CORNER_RADIUS_BOUNDS.max);
			} else {
				setSize(themeNodeStyle, newSize);
			}
		},
		increment = function (themeNodeStyle) {
			incrementCornerRadius(themeNodeStyle, 1);
		},
		decrement = function (themeNodeStyle) {
			incrementCornerRadius(themeNodeStyle, -1);
		},
		reset = (themeNodeStyle) => {
			setSize(themeNodeStyle, false);
		},
		actions = {increment, decrement, reset};

	return mmWidgets.each(this, function () {
		const widget = this;
		widget.click(() => {
			const themeNodeStyle = widget.attr('data-mm-theme-corner-radius'),
				operation = widget.attr('data-mm-corner-radius');
			actions[operation](themeNodeStyle);
		});
	});
};

